
// This file serves as a compatibility layer for code that still uses useCategories
// It re-exports useProducts under the old name useCategories

import { useProducts } from "./useProducts";

export function useCategories() {
  const {
    products,
    loading,
    fetchProducts,
    createProduct,
    updateProduct,
    deleteProduct
  } = useProducts();

  return {
    categories: products,
    loading,
    fetchCategories: fetchProducts,
    createCategory: createProduct, 
    updateCategory: updateProduct,
    deleteCategory: deleteProduct
  };
}
